module.exports = __webpack_public_path__ + "img/play.762aa104.png";